<!-- *FORMULARIO GUARDAR ROL SESION -->
<app-lfsa-card-v2 *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateForm"
    [innTemplateButton]="innTemplateButtonForm" [titulo]="DAT_TITULOS.titulo" [modulo]="DAT_TITULOS.modulo"
    [tituloCard]="titulo">
</app-lfsa-card-v2>
<ng-template #innTemplateButtonForm>
</ng-template>
<ng-template #enviarTemplateForm>
    <form [formGroup]="formulario" novalidate class="form-group">
        <div class="row">
            <div class="form-group col-md-4">
                <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'id'" [habilitar]="cmbDisabled"
                    [comboBox]="cmbListRol" formControlName="rolId" [control]="formulario.get('rolId')" [label]="'Rol*'"
                    [id]="'idRol'"></app-lfsa-combo-box>
            </div>
            <div class="form-group col-md-4">
                <app-lfsa-combo-box [claseLabel]="'letrasDanger'" (change)="changeAplicacion($event.target)" [opcion]="'application'"
                    [idOpcion]="'application'" [habilitar]="cmbDisabled" [comboBox]="cmbListAplicacion"
                    formControlName="application" [control]="formulario.get('application')" [label]="'Aplicacion*'"
                    [id]="'aplicacion'"></app-lfsa-combo-box>
            </div>
            <div class="form-group col-md-4">
                <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'id'" [habilitar]="cmbDisabled"
                    [comboBox]="cmbListSesion" formControlName="sesionId" [control]="formulario.get('sesionId')"
                    [label]="'Sesion*'" [id]="'idSesion'">
                </app-lfsa-combo-box>
            </div>
        </div>
        <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones ( $event )"
            [textBoton]="textBoton"></app-lfsa-botones-formulario>
    </form>
</ng-template>

<!-- *GRID LISTAR ROL SESION -->
<app-lfsa-card-v2 *ngIf="!mostrarFormulario" [innTemplate]="enviarTemplate" [innTemplateButton]="innTemplateButton"
    [titulo]="DAT_TITULOS.titulo" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
    <div class="col-md-6">
        <div class="pagetitle">
            <div class="btn-group-justified btn-group" style="float: right;">
                <a class="btn btn-outline-success" (click)="nuevo()">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    {{DAT_BTNS.agregarRol}}</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #enviarTemplate>
    <ag-grid-angular [floatingFilter]="true" class="{{diccionarioModulo.agGrid.class}}" #agGrid
        [ngStyle]="diccionarioModulo.agGrid.style" id="{{diccionarioModulo.agGrid.id}}"
        [paginationPageSize]="$any(diccionarioModulo.agGrid).paginacion" [pagination]="true"
        [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs " [rowSelection]="rowSelection "
        [rowData]="rowData " (gridReady)="onGridReady($event) ">
    </ag-grid-angular>
</ng-template>
